import React, { useContext } from 'react';
import { useLoader } from '../../api/useLoader';
import { MuligePraksisstedDto } from '../../api/generated/studiested-generated-api';
import { StudiestedApiContext } from '../../api/StudiestedApiContext';
import { StedType } from '../../components/hierarchy/onhoverhierarchyinfo';
import { IndentMuligPraksissted } from '../../components/indentation/indentation';
import Autocomplete, {
  AutocompleteOption,
} from '../../components/input/autocomplete';
import translations from '../rolleliste.i18n';
import { useFormatMessageFor } from '../../i18n/translation';
import * as css from '../rolleliste.module.scss';
import { useActivityContextUHA } from '../activitycontexts';

const useLoadPraksissteder = () => {
  const { praksisstedApi } = useContext(StudiestedApiContext);
  const { praksisaktivitet } = useActivityContextUHA();
  const { id: aktivitetsId } = praksisaktivitet;

  const { data: praksissteder, loading: praksisstederLoading } = useLoader(
    () =>
      praksisstedApi.praksisaktiviteterAktivitetsIdAvtalerPraksisstederGet({
        pathParams: { aktivitetsId: aktivitetsId },
      }),
    [aktivitetsId],
  );

  return { praksissteder, praksisstederLoading };
};

const getOptionPraksissted = (
  praksissted: MuligePraksisstedDto,
): AutocompleteOption => ({
  ...praksissted,
  onHoverType: StedType.PRAKSISSTED,
});

interface RollelistePraksisstederDropDownProps {
  id: string;
  defaultPraksissted: MuligePraksisstedDto | undefined;
  onChange: (selectedItem: MuligePraksisstedDto) => void;
}

const RollelistePraksisstederDropDown = ({
  id,
  defaultPraksissted,
  onChange,
}: RollelistePraksisstederDropDownProps) => {
  const labels = useFormatMessageFor(translations);

  const { praksissteder, praksisstederLoading } = useLoadPraksissteder();

  const defaultValue =
    defaultPraksissted && getOptionPraksissted(defaultPraksissted);
  const options = praksissteder?.map(getOptionPraksissted);

  return (
    <>
      <div className={css.praksissstedInfoLabel}>
        {labels.praksisstederInfoTekstKapasitet}
      </div>

      <Autocomplete
        id={`rolles-ps-steder-autocomplete-${id}`}
        loading={praksisstederLoading}
        label={labels.practicePlacesWithAgreement}
        defaultValue={defaultValue}
        options={options}
        renderOption={(option) => (
          <IndentMuligPraksissted praksissted={option} />
        )}
        onChange={(event: object, value: MuligePraksisstedDto) => {
          onChange(value);
        }}
        noOptionsText={labels.praksisstederInfoTekstIngenKapasitet}
      />
    </>
  );
};

export default RollelistePraksisstederDropDown;
